<template>
  <CookieTemplate>
    <CookieContent
      slot="content"
      :text="translate('COOKIE_TEXT', $store.state.lang)"
    />
    <CookieButton slot="button" :label="translate('COOKIE_BTN', $store.state.lang)" />
  </CookieTemplate>
</template>

<script>
import translate from '@/assets/i18n';

import CookieTemplate from '@/components/Cookie/index.vue';
import CookieContent from '@/components/Cookie/CookieContent';
import CookieButton from '@/components/Cookie/CookieButton';

export default {
  name: 'Cookie',

  components: {
    CookieTemplate,
    CookieContent,
    CookieButton,
  },

  data() {
    return {
      translate
    };
  }
};
</script>

<style>

</style>
